module.exports = __webpack_public_path__ + "img/Files.fc4d0dfc.svg";